import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Alert, Spin, Button, Input, message } from 'antd'
import { getRemoteDatabases } from '../../common/requests'

export default class GreyfinchSync extends Component {
  static propTypes = {
    practiceId: PropTypes.string.isRequired,
  }

  state = {
    remoteDb: null,
    loading: true,
    error: null,
  }

  componentDidMount() {
    const { practiceId } = this.props

    getRemoteDatabases(practiceId)
      .then((res) => {
        if (res.length && res[0].key && res[0].secret) {
          const db = res[0]
          this.setState({
            remoteDb: db,
            loading: false,
          })
        } else {
          this.setState({ loading: false })
        }
      })
      .catch((error) => {
        this.setState({
          loading: false,
          error: error.message,
        })
      })
  }

  copyToClipboard = (link) => {
    navigator.clipboard.writeText(link).then(() => {
      message.success('Link copied to clipboard!')
    }).catch(() => {
      message.error('Failed to copy link')
    })
  }

  render() {
    const { practiceId } = this.props
    const { remoteDb, loading, error } = this.state
    const isSynced = !!remoteDb
    const baseIntegrationLink = 'https://admin.greyfinch.com/settings/apps/install/27ed1554-632b-4a23-833f-eb83cc2af200'
    const integrationLink = `${baseIntegrationLink}?practiceId=${practiceId}&rgEnv=production&forceInstall=true`

    if (error) {
      return (
        <Alert
          message="Greyfinch Connection Error"
          description={`Failed to connect: ${error}`}
          type="error"
          showIcon
        />
      )
    }

    return (
      <Spin spinning={loading}>
        <Alert
          message="Greyfinch Auto Integration"
          description={
            isSynced
              ? 'Successfully integrated with Greyfinch'
              : 'Not connected to Greyfinch'
          }
          type={isSynced ? 'success' : 'error'}
          showIcon
        />

        {!isSynced && (
          <Alert
            message="Setup Required"
            description={
              <div>
                <p>
                  {`No connection established between Greyfinch and Rooster Grin. 
                    Please have the client install the Rooster Grin App in their Greyfinch PMS 
                    by using the link below:`}
                </p>
                <div style={{ marginTop: '12px' }}>
                  <Input.Group compact>
                    <Input
                      style={{ width: 'calc(100% - 80px)' }}
                      value={integrationLink}
                      readOnly
                    />
                    <Button
                      type="primary"
                      onClick={() => this.copyToClipboard(integrationLink)}
                      style={{ width: '80px' }}
                    >
                      Copy
                    </Button>
                  </Input.Group>
                </div>
              </div>
            }
            type="info"
            showIcon
            style={{ marginTop: '16px' }}
          />
        )}
      </Spin>
    )
  }
}



// WEBPACK FOOTER //
// ./src/AddPractice/Info/GreyfinchSync.js